// ClimatologyADCForm.jsx
import { Grid } from '@mui/material'
import "../../css/DemoCode.css"

/**
 * Options Dynamic Wave Form is a group of data inputs usually shown when clicking on Options->Dynamic Wave. 
 * 
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {function} setModel Update function for updating 'model'.
 * @returns UI for interactive swmm modeling.
 */
export default function ClimatologyADCForm({model, setModel}) {
  const objsIndexes = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
  // When there is a change to an input element, modify the model.
  const updateValue = (val, type, position) => {
    // Don't let any undefined updates go through.
    if(val === undefined) val = ''
    if(model && model.TEMPERATURE){
      let newADC = model.TEMPERATURE.ADC[type]
      newADC[position] = val

      setModel(prev => ({
        ...prev,
        TEMPERATURE:{
          ...prev.TEMPERATURE,
          ADC: {
            ...prev.TEMPERATURE.ADC,
            [type]: newADC
          }
        }
      }))
    }
  }

  return(
    <>
    {
      model.TEMPERATURE &&
      model.TEMPERATURE.ADC &&
      <>
      <Grid container>
        <Grid item xs={4}>
          <div style={{borderBottom:'3px solid #fff'}}>Depth Ratio</div>
          <label className='editor-small' >0.0</label>
          <label className='editor-small' >0.1</label>
          <label className='editor-small' >0.2</label>
          <label className='editor-small' >0.3</label>
          <label className='editor-small' >0.4</label>
          <label className='editor-small' >0.5</label>
          <label className='editor-small' >0.6</label>
          <label className='editor-small' >0.7</label>
          <label className='editor-small' >0.8</label>
          <label className='editor-small' >0.9</label>
        </Grid>
        <Grid item xs={4}>
          <div style={{borderBottom:'3px solid #fff'}}>Impervious</div>
          {
            objsIndexes.map(v=>
              <input  type = "number"
                      style={{width: '95%', display: 'flex'}}
                      onChange={(e)=>{updateValue(e.target.value, 'IMPERVIOUS', v)}}
                      value={model.TEMPERATURE.ADC.IMPERVIOUS[v]}
                      id={'ClimatologyADCImp'+v.toString()}
                      key={'ClimatologyADCImp'+v.toString()}
              />
            )
          }
        </Grid>
        <Grid item xs={4}>
          <div style={{borderBottom:'3px solid #fff'}}>Pervious</div>
          {
            objsIndexes.map(v=>
              <input  type = "number"
                      style={{width: '95%', display: 'flex'}}
                      onChange={(e)=>{updateValue(e.target.value, 'PERVIOUS', v)}}
                      value={model.TEMPERATURE.ADC.PERVIOUS[v]}
                      id={'ClimatologyADCPer'+v.toString()}
                      key={'ClimatologyADCImp'+v.toString()}
              />
            )
          }
        </Grid>
      </Grid>
      </>
    }
    </>
  )
}